import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import 'aos/dist/aos.css';
import AOS from 'aos';
import {
  FaPhoneAlt,
  FaEnvelope,
  FaMapMarkerAlt,
  FaFacebookF,
  FaTwitter,
  FaLinkedinIn,
  FaInstagram,
  FaYoutube,        // ← Added YouTube icon
  FaAngleRight, 
} from 'react-icons/fa';

const Footer = () => {
  useEffect(() => {
    AOS.init({
      duration: 800,
      once: true,
      easing: 'ease-in-out',
      disable: 'mobile',
    });
  }, []);

  // --- Configuration Data ---
  const quickLinks = [
    { to: '/', label: 'Home' },
    { to: '/who-we-are', label: 'About Us' },
    { to: '/our-services', label: 'Services & Products' },
    { to: '/blogs', label: 'Blogs' },
    { to: '/careers', label: 'Careers & Benefits' },
    { to: '/terms', label: 'Terms & Conditions' },
    { to: '/contact-us', label: 'Contact Us' },
  ];

  const services = [
    { to: '/custom-software-development', label: 'Software Development Services' },
    { to: '/it-support-services', label: 'IT Consulting & Managed Services' },
    { to: '/cloud-service-providers', label: 'Cloud & Beyonds' },
    { to: '/bpo-services', label: 'Business Process Services' },
    { to: '/data-analytics-services', label: 'AI & Data Analytics Solutions' },
    { to: '/digital-marketing-services', label: 'Digital Marketing & Experience Design' },
    { to: '/ui-ux-design-services', label: 'UI/UX-Design-Services' },
    { to: '/cybersecurity-services', label: 'Cybersecurity-Services' },
  ];
  
  const socialLinks = [
      { Icon: FaFacebookF, url: 'https://www.facebook.com/profile.php?id=61576099186187' },
      { Icon: FaInstagram, url: 'https://www.instagram.com/securxpert' },
      { Icon: FaLinkedinIn, url: 'https://www.linkedin.com/company/securxpert-technologies-pvt-ltd/posts/?feedView=all' },
      { Icon: FaYoutube, url: 'https://www.youtube.com/@SecurXpert' },
      // Twitter kept as placeholder (you can update later if needed)
  ];

  // Colors
  const BG_COLOR = 'bg-gray-100';
  const TEXT_COLOR = 'text-gray-700';
  const HEADING_COLOR = 'text-gray-900';
  const ACCENT_COLOR = 'text-indigo-600';

  return (
    <footer className={`${BG_COLOR} ${TEXT_COLOR} py-12 sm:py-16 font-sans relative`}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        
        <div className="grid grid-cols-1 gap-y-10 sm:grid-cols-2 sm:gap-y-12 lg:grid-cols-4 lg:gap-x-8">
          
          {/* Column 1: Logo, Guarantee Text, Social Links */}
          <div className="lg:col-span-1" data-aos="fade-up" data-aos-delay="100">
            <div className="mb-4">
              <img 
                src="/img/LOGO.png" 
                alt="SecurXpert Technologies Logo" 
                className="h-10 object-contain"
              />
            </div>

            <p className="text-sm my-4 text-gray-600 leading-relaxed max-w-xs">
              100% Service Quality Certified Agency Satisfaction Guarantee
            </p>

        {/* WE ARE REVIEWED - IMAGE SCROLL */}
<div className="mt-1 overflow-hidden">
  {/* <h3 className="text-center text-sm tracking-widest text-orange-400 font-semibold mb-6">
    WE ARE REVIEWED
  </h3> */}

{/* <div className="relative w-full overflow-hidden">
  <div className="flex gap-10 animate-scroll">
    {[
      {
        img: "/img/clutch PNG.png",
        link: "https://clutch.co/profile/securxpert-technologies",
      },
      {
        img: "/img/goodfirms PNG.png",
        link: "https://www.goodfirms.co/company/securxperts-technologies-pvt-ltd",
      },
      {
        img: "/img/businessfirms.png",
        link: "https://businessfirms.co/company/securxpert-technologies-pvt-ltd",
      },
      {
        img: "/img/Softwareworld PNG.png",
        link: "https://www.softwareworld.co/",
      },
    ].map((item, idx) => (
      <a
        key={idx}
        href={item.link}
        target="_blank"
        rel="noopener noreferrer"
        className="w-40 h-20 bg-white rounded-xl shadow-sm flex items-center justify-center hover:shadow-md transition"
      >
        <img
          src={item.img}
          alt="Review Badge"
          className=" object-fit"
        />
      </a>
    ))}
  </div>
 <img
  src="/img/ios.jpg"
  alt="img"
  className="w-38 h-28 mt-4 mx-auto object-contain"
/>

</div> */}
<div className="relative w-full overflow-hidden">
  {/* Scrolling badges */}
  <div className="flex gap-10 animate-scroll">
    {[
      {
        img: "/img/clutch PNG.png",
        link: "https://clutch.co/profile/securxpert-technologies",
      },
      {
        img: "/img/goodfirms PNG.png",
        link: "https://www.goodfirms.co/company/securxperts-technologies-pvt-ltd",
      },
      {
        img: "/img/businessfirms.png",
        link: "https://businessfirms.co/company/securxpert-technologies-pvt-ltd",
      },
      {
        img: "/img/Softwareworld PNG.png",
        link: "https://www.softwareworld.co/",
      },
    ].map((item, idx) => (
      <a
        key={idx}
        href={item.link}
        target="_blank"
        rel="noopener noreferrer"
        className="w-40 h-20 bg-white rounded-xl shadow-sm flex items-center justify-center hover:shadow-md transition"
      >
        <img
          src={item.img}
          alt="Review Badge"
          className="max-h-14 object-contain"
        />
      </a>
    ))}
  </div>

  {/* ISO badge aligned like others */}
  <div className="flex justify-center mt-6">
    <div className="w-40 h-28 bg-white rounded-xl shadow-sm flex items-center justify-center">
      <img
        src="/img/ios.jpg"
        alt="ISO Certification"
        className="w-24 h-24 object-contain"
      />
    </div>
  </div>
</div>



</div>


            {/* Social Links */}
            <div className="flex space-x-3 mt-6">
                {socialLinks.map((item, index) => (
                    <a 
                        key={index} 
                        href={item.url} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className={`w-9 h-9 flex items-center justify-center rounded-full border border-gray-300 ${TEXT_COLOR} hover:bg-indigo-600 hover:border-indigo-600 hover:text-white transition duration-300`}
                        aria-label={`Link to ${item.Icon.name}`}
                    >
                        <item.Icon className="w-4 h-4" />
                    </a>
                ))}
            </div>
          </div>
          
          {/* Column 2: Quick Links */}
          <div className="sm:col-span-1 lg:col-span-1" data-aos="fade-up" data-aos-delay="200">
            <h3 className={`font-extrabold text-sm uppercase mb-8 ${HEADING_COLOR} relative footer-heading`}>
              Quick Links
            </h3>
            <ul className="space-y-3">
              {quickLinks.map((link, index) => (
                <li key={index}>
                  <Link
                    to={link.to}
                    className={`flex items-center text-sm ${TEXT_COLOR} hover:${ACCENT_COLOR} transition-colors duration-200`}
                  >
                    <FaAngleRight className={`w-3 h-3 mr-2 ${ACCENT_COLOR} flex-shrink-0`} />
                    {link.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Column 3: Services */}
          <div className="sm:col-span-1 lg:col-span-1" data-aos="fade-up" data-aos-delay="300">
            <h3 className={`font-extrabold text-sm uppercase mb-8 ${HEADING_COLOR} relative footer-heading`}>
              Services
            </h3>
            <ul className="space-y-3">
              {services.map((service, index) => (
                <li key={index}>
                  <Link
                    to={service.to}
                    className={`flex items-start text-sm ${TEXT_COLOR} hover:${ACCENT_COLOR} transition-colors duration-200`}
                  >
                    <FaAngleRight className={`w-3 h-3 mr-2 mt-1 ${ACCENT_COLOR} flex-shrink-0`} />
                    {service.label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>
          
          {/* Column 4: Contact Us */}
          <div className="sm:col-span-2 lg:col-span-1" data-aos="fade-up" data-aos-delay="400">
            <h3 className={`font-extrabold text-sm uppercase mb-8 ${HEADING_COLOR} relative footer-heading`}>
              Contact Us
            </h3>
            
            <div className="space-y-6">
              <div className="flex items-start">
                <div className={`p-3 rounded-lg ${ACCENT_COLOR} bg-indigo-100 flex-shrink-0 mr-4`}>
                  <FaPhoneAlt className="w-5 h-5" />
                </div>
                <div>
                  <span className="block text-xs uppercase text-gray-500 font-semibold mb-1">Phone Number</span>
                  <a href="tel:+917933256679" className={`text-sm font-bold ${HEADING_COLOR} hover:${ACCENT_COLOR}`}>
                    +91 79332 56679
                  </a>
                </div>
              </div>
              
              <div className="flex items-start">
                <div className={`p-3 rounded-lg ${ACCENT_COLOR} bg-indigo-100 flex-shrink-0 mr-4`}>
                  <FaEnvelope className="w-5 h-5" />
                </div>
                <div>
                  <span className="block text-xs uppercase text-gray-500 font-semibold mb-1">Email Address</span>
                  <a href="mailto:info@SecurXperts.com" className={`text-sm font-bold ${HEADING_COLOR} hover:${ACCENT_COLOR}`}>
                    info@SecurXperts.com
                  </a>
                </div>
              </div>

              <div className="flex items-start">
                <div className={`p-3 rounded-lg ${ACCENT_COLOR} bg-indigo-100 flex-shrink-0 mr-4`}>
                  <FaMapMarkerAlt className="w-5 h-5" />
                </div>
                <div>
                  <span className="block text-xs uppercase text-gray-500 font-semibold mb-1">India Address</span>
                  <p className="text-sm font-medium leading-relaxed text-gray-600">
                    3rd Floor, PR R One Towers, Plot No 59, DLF Rd, near Radisson Hotel, Jayabheri Enclave, Gachibowli, Hyderabad, Telangana 500032
                  </p>
                </div>
                
              </div>

               <div className="flex items-start">
                <div className={`p-3 rounded-lg ${ACCENT_COLOR} bg-indigo-100 flex-shrink-0 mr-4`}>
                  <FaMapMarkerAlt className="w-5 h-5" />
                </div>
                <div>
                  <span className="block text-xs uppercase text-gray-500 font-semibold mb-1">UK Address </span>
                  <p className="text-sm font-medium leading-relaxed text-gray-600">
                   194 Gulson Road,
Coventry, England, CV1 2JD
United Kingdom
                  </p>
                </div>
                
              </div>
            </div>
          </div>
        </div>



        
        {/* Copyright */}
        <div className="mt-12 sm:mt-16 pt-6 border-t border-gray-300 text-center">
          <p className="text-sm font-light text-gray-500">
            &copy; {new Date().getFullYear()} SecurXpert Technologies. All rights reserved.
          </p>
        </div>
      </div>

      {/* Custom CSS */}
      <style jsx>{`
        .footer-heading {
          padding-bottom: 10px; 
        }
        .footer-heading::after {
          content: '';
          display: block;
          width: 40px; 
          height: 3px;
          background-color: #4f46e5;
          position: absolute;
          bottom: 0;
          left: 0;
          border-radius: 1px;
        }
          @keyframes scroll {
  0% {
    transform: translateX(0);
  }
  100% {
    transform: translateX(-50%);
  }
}

.animate-scroll {
  animation: scroll 18s linear infinite;
  width: max-content;
}

      `}</style>
      
    </footer>
  );
};

export default Footer;